import { apiUrl, eventToken } from 'network/common/cmsConfig';
import request from 'graphql-request';
import { CommonLocalizableString } from 'network/common/cmsFragment';

const fetchXtraEventQuery = `
  query fetchXtraEventQuery($eventToken: String!) {
    data: eventByToken(eventToken: $eventToken) {
      id
      locales
      defaultLocale
    }
  }
`;

export const fetchXtraEventRequest = () => request(
  apiUrl,
  fetchXtraEventQuery,
  {
    eventToken,
  },
).then((response) => response.data);

const fetchBoothTaxonomiesQuery = `
  ${CommonLocalizableString}

  query fetchBoothTaxonomiesQuery($eventToken: String!, $locales: [Locale!]!, $boothTaxonomiesCount: Int, $boothTaxonomiesCursor: String) {
    data: eventByToken(eventToken: $eventToken) {
      id
      boothTaxonomies (first: $boothTaxonomiesCount, after: $boothTaxonomiesCursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ... on BoothSupercategory {
            id
            name {
              ...CommonLocalizableString
            }
            subcategories {
              nodes {
                id
                name {
                  ...CommonLocalizableString
                }
              }
            }
          }
        }
      }
    }
  }
`;

export interface FetchBoothTaxonomiesQueryProps {
  locales?: string[];
  boothTaxonomiesCursor?: string;
  boothTaxonomiesCount?: number;
}

export const fetchBoothTaxonomiesQueryRequest = ({
  locales = ['en'],
  boothTaxonomiesCount = 20,
  boothTaxonomiesCursor,
}: FetchBoothTaxonomiesQueryProps = {}) => request(
  apiUrl,
  fetchBoothTaxonomiesQuery,
  {
    eventToken,
    locales,
    boothTaxonomiesCount,
    boothTaxonomiesCursor,
  },
).then((response) => response.data);
